"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTimeField = void 0;
const time_field_1 = require("../../../components/time-field/time-field");
const form_field_1 = require("./form-field");
exports.FormTimeField = form_field_1.formFieldFactory(time_field_1.TimeField);
//# sourceMappingURL=form-time-field.js.map